<template>
  <v-card
    class="ma-0 mx-2 pt-0"
    width="100%"
    flat
  >
    <div class="d-flex mt-0">
      <v-chip-group
        v-model="page"
        style="max-width: 78%"
        active-class="primary--text"
      >
        <v-badge
          v-for="(item, i) in pageItems"
          :key="i"
          bordered
          color="blue"
          :value="editStatus"
          dot
          overlap
          offset-x="15"
          offset-y="15"
        >
          <v-chip
            :value="item"
            class="ms-0 me-2"
            @click="(editStatus ? openEditPageDialog(item) : selectPage(item))"
          >
            {{ item.name }}
          </v-chip>
        </v-badge>
      </v-chip-group>
      <v-chip
        class="ms-0 ms-0 mt-2"
        color="primary"
        @click="openNewPageDialog"
      >
        {{ $t('newPage') }}
        <v-icon
          color="white"
          style="font-size: 20px"
          class="ms-2"
        >
          mdi-plus
        </v-icon>
      </v-chip>
      <v-spacer />
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            icon
            small
            class="float-left mt-3"
            v-on="on"
            @click="editStatus = !editStatus"
          >
            <v-icon
              x-small
              color="primary"
              style="font-size: 22px"
            >
              {{ (editStatus ? 'mdi-pencil-off-outline' : 'mdi-pencil-outline') }}
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t('editItems') }}</span>
      </v-tooltip>
    </div>
    <div
      :style="{height: (isMobile ? tableHeightInvoice + 65 : tableHeightInvoice - 43) + 'px'}"
      style="overflow-y: scroll;min-height: 233px;"
      class="d-flex"
    >
      <v-card
        class="d-flex align-content-start flex-wrap ma-0"
        style="width: 100%"
        flat
        tile
      >
        <v-badge
          v-for="(item, i) in items"
          :key="i"
          bordered
          color="blue"
          :value="editStatus"
          dot
          overlap
          offset-x="11"
          offset-y="11"
          style="width: 16.66%"
        >
          <v-card
            class="pa-0 ma-0"
            width="100%"
            flat
            style=""
          >
            <v-card
              tile
              outlined
              class="ma-1 pa-2 px-1 pt-1 text-center"
              style="font-size: 12px;line-height: 16px;cursor: pointer;background-color: #00bcd48f;border-radius: 5px !important"
              height="70"
              @click="setItem(item)"
            >
              {{ (item.name && item.name.length > 40 ? item.name.substring(0,40) + '...' : item.name) }}
            </v-card>
          </v-card>
        </v-badge>
        <v-card
          class="pa-0 ma-0 justify-center"
          width="16.66%"
          flat
        >
          <v-card
            tile
            outlined
            align="center"
            class="ma-1 pa-2"
            height="70"
            style="border-radius: 5px !important;background-color: #f0f8ff"
            @click="openItemDialog"
          >
            <v-icon
              color="primary"
              class="text-center mt-3"
              style="font-size: 30px"
            >
              mdi-plus
            </v-icon>
          </v-card>
        </v-card>
      </v-card>
    </div>
    <!--    dialogs-->
    <v-dialog
      v-model="newPageDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="95%"
    >
      <v-card>
        <v-col class="d-flex pt-2 pb-0">
          <v-btn
            icon
            @click="newPageDialog = false"
          >
            <v-icon
              class="close-hover"
              large
              color="grey"
            >
              mdi-close
            </v-icon>
          </v-btn>
        </v-col>
        <v-card-text class="pa-0">
          <v-col
            cols="12"
          >
            <v-text-field
              v-model="namePage"
              height="20"
              dense
              :rules="[v => !!v || $t('is-required')]"
              outlined
              clearable
              :label="$t('namePage')"
            />
          </v-col>
        </v-card-text>
        <v-card-actions class="px-3">
          <v-col
            class="px-0"
            cols="6"
          >
            <v-btn
              color="primary"
              :disabled="(!namePage)"
              :loading="isLoading"
              @click="pageCreate"
            >
              {{ $t('submit') }}
            </v-btn>
          </v-col>
          <v-spacer />
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="editPageDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="95%"
    >
      <v-card>
        <v-col class="d-flex pt-2 pb-0">
          <v-btn
            icon
            @click="editPageDialog = false"
          >
            <v-icon
              class="close-hover"
              large
              color="grey"
            >
              mdi-close
            </v-icon>
          </v-btn>
        </v-col>
        <v-card-text class="pa-0">
          <v-col
            cols="12"
          >
            <v-text-field
              v-model="editpageItemName"
              height="20"
              dense
              :rules="[v => !!v || $t('is-required')]"
              outlined
              clearable
              :label="$t('namePage')"
            />
          </v-col>
        </v-card-text>
        <v-card-actions class="px-3">
          <v-col
            class="px-0"
            cols="6"
          >
            <v-btn
              color="primary"
              :loading="isLoading"
              @click="pageUpdate"
            >
              {{ $t('edit') }}
            </v-btn>
          </v-col>
          <v-spacer />
          <v-col
            class="px-0 d-flex flex-row-reverse"
            cols="6"
          >
            <v-btn
              color="pink"
              :loading="isLoading"
              @click="removePage"
            >
              {{ $t('remove') }}
            </v-btn>
          </v-col>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="itemDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="95%"
    >
      <v-card>
        <v-col class="d-flex pt-2 pb-0">
          <v-btn
            icon
            @click="itemDialog = false"
          >
            <v-icon
              class="close-hover"
              large
              color="grey"
            >
              mdi-close
            </v-icon>
          </v-btn>
        </v-col>
        <v-card-text class="pa-0">
          <v-row class="mx-0 mt-4">
            <v-col
              class="ma-0"
              cols="12"
              md="4"
            >
              <offlineProductAutocomplete
                ref="refBarcode"
                v-model="product"
                title="barcode/otherFields"
                type="integrator"
              />
            </v-col>
            <v-col
              class="ma-0"
              cols="12"
              md="4"
            >
              <offlineProductAutocomplete
                v-model="product"
                title="productName"
                type="product"
              />
            </v-col>
            <v-col
              class="ma-0"
              cols="12"
              md="4"
            >
              <offlineProductAutocomplete
                v-model="product"
                title="productCode"
                type="productCode"
              />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="px-3 mt-4">
          <v-col
            class="px-0"
            cols="6"
          >
            <v-btn
              v-if="!itemEditStatus"
              color="primary"
              :loading="isLoading"
              @click="itemCreate"
            >
              {{ $t('submit') }}
            </v-btn>
            <v-btn
              v-if="itemEditStatus"
              color="primary"
              :loading="isLoading"
              @click="itemUpdate"
            >
              {{ $t('update') }}
            </v-btn>
          </v-col>
          <v-spacer />
          <v-col
            class="px-0 d-flex flex-row-reverse"
            cols="6"
          >
            <v-btn
              v-if="itemEditStatus"
              color="pink"
              :loading="isLoading"
              @click="itemRemove"
            >
              {{ $t('remove') }}
            </v-btn>
          </v-col>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--    dialogs-->
  </v-card>
</template>

<script>
// import Product from '@/views/dashboard/pages/product/product.vue'

  export default {
    name: 'ProductShortcut',
    components: {
      offlineProductAutocomplete: () => import('./offlineProductAutocomplete.vue'),
    },
    props: [],
    data () {
      return {
        pageTemp: null,
        product: false,
        itemDialog: false,
        editStatus: false,
        isLoading: false,
        editPageDialog: false,
        newPageDialog: false,
        itemSelect: null,
        itemEditStatus: false,
        page: null,
        editpageItemName: null,
        editpageItem: null,
        items: [],
        namePage: null,
        pageItems: [],
      }
    },
    computed: {
      reloadShortcut: {
        get () {
          return this.$store.state.reloadShortcut
        },
        set (val) {
          this.$store.commit('SET_RELOADSHORTCUT', val)
        },
      },
      tableHeightInvoice: {
        get () {
          return this.$store.state.tableHeightInvoice
        },
        set (val) {
          this.$store.commit('SET_RELOAD', val)
        },
      },
    },
    watch: {
      reloadShortcut (val) {
        if (val) {
          this.getPages()
          this.$store.commit('SET_RELOADSHORTCUT', false)
        }
      },
      tableHeightInvoice (val) {
      },
      page (val) {
        if (val) {
          this.getShortcut()
        }
      },
    },
    activated: function () {
    },
    mounted () {
      this.getPages()
    },
    created () {
    // window.addEventListener('resize', this.resizeHeightBody)
    },
    destroyed () {
    // window.removeEventListener('resize', this.resizeHeightBody)
    },
    beforeDestroy () {
    // window.removeEventListener('resize', this.onResize)
    },
    methods: {
      openItemDialog () {
        this.product = null
        this.itemSelect = null
        this.itemDialog = true
      },
      itemCreate () {
        if (this.product && this.page) {
          var app = this
          this.isLoading = true
          app.$axios.get(this.$endpoint + 'productpageshortcut', {
            params: {
              addItem: 'active',
              product: app.product.id,
              unit: app.product.unit_id,
              page: app.page.id,
            },
          })
            .then(res => {
              res = res.data
              app.pageTemp = app.page
              app.getAllProductShortcutItemsOffline()
              app.itemDialog = false
            })
            .catch(err => {
              this.serverErrorHandeler(err)
            })
            .finally(() => (app.isLoading = false))
        }
      },
      itemUpdate () {
        if (this.product && this.page) {
          var app = this
          this.isLoading = true
          app.$axios.get(this.$endpoint + 'productpageshortcut', {
            params: {
              updateItem: 'active',
              id: app.itemSelect.item_id,
              unit: app.product.unit_id,
              product: app.product.id,
              page: app.page.id,
            },
          })
            .then(res => {
              res = res.data
              app.pageTemp = app.page
              app.getAllProductShortcutItemsOffline()
              app.itemDialog = false
              app.itemEditStatus = false
            })
            .catch(err => {
              this.serverErrorHandeler(err)
            })
            .finally(() => (app.isLoading = false))
        }
      },
      itemRemove () {
        if (this.product && this.page) {
          var app = this
          this.isLoading = true
          app.$axios.get(this.$endpoint + 'productpageshortcut', {
            params: {
              deleteItem: 'active',
              id: app.product.item_id,
            },
          })
            .then(res => {
              res = res.data
              app.pageTemp = app.page
              app.getAllProductShortcutItemsOffline()
              app.itemDialog = false
              app.itemEditStatus = false
            })
            .catch(err => {
              this.serverErrorHandeler(err)
            })
            .finally(() => (app.isLoading = false))
        }
      },
      removeItem () {
      },
      selectPage (item) {
      },
      openNewPageDialog () {
        this.newPageDialog = true
      },
      openEditPageDialog (item) {
        this.editpageItem = item
        this.editpageItemName = item.name
        this.editPageDialog = true
      },
      pageCreate () {
        var app = this
        app.isLoading = true
        const formData = new FormData()
        formData.append('name', this.namePage)
        app.$axios.post(this.$endpoint + 'productpageshortcut', formData)
          .then(res => {
            res = res.data
            app.pageTemp = res.data
            app.namePage = null
            app.newPageDialog = false
            app.getAllProductShortcutOffline()
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => {
            this.isLoading = false
            app.snakbar = false
          })
      },
      pageUpdate () {
        var app = this
        app.isLoading = true
        var data = {
          name: this.editpageItemName,
        }
        app.$axios.put(this.$endpoint + 'productpageshortcut/' + this.editpageItem.id, data)
          .then(res => {
            res = res.data
            app.getAllProductShortcutOffline()
            app.pageTemp = app.editpageItem
            app.editpageItem = null
            app.editpageItemName = null
            app.editPageDialog = false
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => {
            this.isLoading = false
            app.snakbar = false
          })
      },
      removePage () {
        var app = this
        app.$axios.delete(this.$endpoint + 'productpageshortcut/' + this.editpageItem.id)
          .then(res => {
            res = res.data
            app.getAllProductShortcutOffline()
            app.editPageDialog = false
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.isLoading = false))
      },
      getItems (type) {
        var app = this
        app.$axios.get(this.$endpoint + 'productpageshortcut', {
          params: {
            type: type,
            page: (app.page ? app.page.id : null),
          },
        })
          .then(res => {
            res = res.data
            if (type === 'page') {
              app.pageItems = res
            } else {
              app.items = res
            }
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.isLoading = false))
      },
      setItem (item) {
        if (this.editStatus) {
          this.product = item
          this.itemSelect = item
          this.itemEditStatus = true
          this.itemDialog = true
        } else {
          this.$emit('append', item)
        }
      },
      getPages () {
        var isDB = localStorage.getItem('dbCreated')
        if (isDB && isDB === 'active') {
          var app = this
          var connection = new window.JsStore.Connection()
          connection.openDb('db_' + this.$store.state.userId)
          connection.select({
            from: 'productShortcut',
          }).then(function (data) {
            app.pageItems = data
            if (data && data.length > 0) {
              if (app.pageTemp) {
                app.page = app.pageTemp
              } else {
                app.page = data[0]
              }
              app.pageTemp = null
              app.getShortcut()
            }
          })
        }
      },
      getShortcut () {
        var isDB = localStorage.getItem('dbCreated')
        if (isDB && isDB === 'active' && this.page) {
          var app = this
          var connection = new window.JsStore.Connection()
          connection.openDb('db_' + this.$store.state.userId)
          connection.select({
            from: 'productShortcutItems',
            where: {
              page_id: app.page.id,
            },
          }).then(function (data) {
            app.items = data
          })
        }
      },
    },
  }
</script>

<style scoped>
.ellip {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  line-height: normal;
}
</style>
